import { WIDGET_FAMILY } from '@config/global-constants';
import { IPdfOptions } from './pdf.type';
import { WIDGET_COMPONENT } from '@app/shared/types';
import { I18n } from '@app/i18n/strings-keys';

const PDF_COLORS = {
  tableLineColor: '#BBBDC0',
  greyBgColor: '#FAFAFA',
  whiteBgColor: '#FFFFFF',
  headerBgColor: '#F5F5F5',
  fontColor: '#323232',
};

/**
 * #TODO need check style define is fetch to new pdf service
 */
const DEFAULT_PDF_OPTIONS: IPdfOptions = {
  isGetInfoEveryTime: true,
  isShownLoadingWhenGenerate: true,
  pageOrientation: 'landscape',
  pageSize: 'A4',
  pageMargins: [20, 20, 20, 60],
  styles: {
    title: {
      margin: [0, 0, 0, 10],
      fontSize: 14,
      bold: true,
    },
    summary: {
      fontSize: 10,
    },
    table: {
      margin: [0, 0, 0, 10],
    },
    footer: {
      fontSize: 8,
      margin: [10, 10, 10, 20],
    },
    footerText: {
      color: PDF_COLORS.fontColor,
    },
  },
};

const DEFAULT_SIGNATURE_LINE_LENGTH = 31;
const DEFAULT_SIGNATURE_SPACE_LENGTH = 2;

const SIGNATURE_LINES_MODAL_DEFINITIONS = {
  value: {
    signature_lines: true,
  },
  schema: {
    properties: {
      signature_lines: {
        type: 'boolean',
      },
    },
  },
  formRules: {
    fields: {
      signature_lines: {
        widgetFamily: WIDGET_FAMILY.XUX,
        widget: WIDGET_COMPONENT.switch,
        title: I18n.Common.SignatureLines,
        description: I18n.InfoMessages.SignatureLinesTooltips,
        widgetData: {
          checkedText: I18n.Common.Yes,
          uncheckedText: I18n.Common.No,
        },
      },
    },
  },
};

const TOTALS_MODAL_DEFINITIONS = {
  value: {
    totals: false,
  },
  schema: {
    properties: {
      totals: {
        type: 'boolean',
      },
    },
  },
  formRules: {
    fields: {
      totals: {
        widgetFamily: WIDGET_FAMILY.XUX,
        widget: WIDGET_COMPONENT.switch,
        title: I18n.Common.Totals,
        description: I18n.InfoMessages.TotalsTooltips,
        widgetData: {
          checkedText: I18n.Common.Yes,
          uncheckedText: I18n.Common.No,
        },
      },
    },
  },
};

export {
  PDF_COLORS,
  DEFAULT_PDF_OPTIONS,
  DEFAULT_SIGNATURE_LINE_LENGTH,
  DEFAULT_SIGNATURE_SPACE_LENGTH,
  SIGNATURE_LINES_MODAL_DEFINITIONS,
  TOTALS_MODAL_DEFINITIONS,
};
